/**
 * What each engine says when a dynamically imported file cannot be loaded: Chromium, WebKit and
 * Firefox for a script, and Vite's own preload error for a stylesheet. A pruned chunk is answered
 * with `index.html`, which WebKit reports as a wrong MIME type rather than a failed import.
 */
const CHUNK_LOAD_MESSAGES: readonly RegExp[] = [
    /Failed to fetch dynamically imported module/i,
    /Importing a module script failed/i,
    /is not a valid JavaScript MIME type/i,
    /error loading dynamically imported module/i,
    /Unable to preload CSS/i,
];

/**
 * Whether a route error is a code chunk that failed to load. A tab left open across a deploy asks
 * for files the deploy removed, and only a reload fetches the new build, so the error screen offers
 * a reload for it wherever it is caught (BUG-139).
 */
export function isChunkLoadError(error: unknown): boolean {
    const message = error instanceof Error ? error.message : typeof error === 'string' ? error : '';
    return CHUNK_LOAD_MESSAGES.some((pattern) => pattern.test(message));
}
